import React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid/index';

const TitleAndDescription = ({descriptions}) => (
  <Grid container spacing={1}>
    <Grid item xs={12}>
      <Typography variant={'h5'}>Overview</Typography>
    </Grid>
    <Grid item xs={12}>
      {descriptions.map((p, i) => (
        <Typography variant={'body1'} paragraph={true} key={i}>
          {p}
        </Typography>
      ))}
    </Grid>
  </Grid>
);

const styles = theme => ({});

export default withStyles(styles)(TitleAndDescription);
